angular.module('charts')
  .directive("gradesList", function() {
      return {
          restrict: "E",
          scope: {
          },
          transclude: true,
          templateUrl: '/resources/charts/partials/grades-list.html',
          controller: [
              '$scope',
              '$element',
              '$timeout',
              'standard',
              'dblAcademicMappingStringCustomizerService',
              'translateFilter',
              function(
                $scope,
                $element,
                $timeout,
                $standard,
                stringCustomizer,
                translateFilter) {

              _init();

              var updateQueryParams = function() {
                  var gradeId = $scope.grades.selected ? $scope.grades.selected.id : undefined;
                  $standard.resetQueryParams({ grade: gradeId });
              };

              function _init() {
                  $scope.grades = { list: [], selected: _getDefaultGrade($scope.astName) };
                  $scope.showPercents = false;
                  _customizePlaceholderTextForAst($scope.astName);
                  $scope.$emit('grade-list-init');
              }

              function _customizePlaceholderTextForAst(astName) {
                  // We need to customize the text for CFLM but we don't want to use the domainText filter because
                  // we don't necessarily want to replace "grade" with "series" universally
                  var searchForGradeString = translateFilter('directives.searchForAGrade');
                  $scope.gradeSearchName = stringCustomizer.render(astName, searchForGradeString);
              }

              function _getDefaultGrade(astName) {
                  var selectAGradeString = translateFilter('directives.selectAGrade');
                  return { name: stringCustomizer.render(astName, selectAGradeString), percent_complete: -1};
              }

              $scope.$on('gradesLoaded', function(e, data, astName) {
                  $standard.updateSelectedGrade(data);
                  $scope.grades.list = _.sortBy(angular.copy(data), 'grade');
                  $scope.astName = astName;

                  _customizePlaceholderTextForAst(astName);

                  var params = $standard.getParams();
                  if(params.grade) {
                      $scope.grades.selected = _.findWhere($scope.grades.list, { id: String(params.grade) });
                  } else {
                      $scope.grades.selected = _.findWhere($scope.grades.list, { queryParamSelected: true }) || _.findWhere($scope.grades.list, {curricular_grade_level: true});
                      updateQueryParams();
                  }

                  // Ensure a grade displays
                  if (_.isUndefined($scope.grades.selected)) {
                      $scope.grades.selected = _getDefaultGrade(astName);
                      updateQueryParams();
                  }

                  $timeout(function() {
                      $scope.$emit('loadDomains');
                  });

              });

              $scope.gradeClicked = function(grade) {
                  $scope.grades.selected = grade;
                  updateQueryParams();

                  $timeout(function() {
                      $scope.$emit('loadDomains');
                  });
              };
          }]
      };
  });
